<template>
	<div>
		<v-container fluid>
			<v-dialog v-model="customizeSettingDialog" max-width="500">
				<v-card>
					<v-card-title class="pb-5">
						{{ $t('GlobalSettingsPage.customize-setting') }}
					</v-card-title>
					<v-card-text class="pb-0">
						<v-row class="justify-center">
							<v-col cols="7">
								<v-autocomplete
									v-model="setting_template.settingId"
									outlined
									dense
									:label="$t('GlobalSettingsPage.setting-name')"
									:items="getGlobalSettings"
									item-text="name"
									item-value="id"
								/>
							</v-col>
							<v-col cols="5" class="d-flex align-center justify-center ">
								<v-switch
									v-model="setting_template.settingValue"
									v-if="getGlobalSettingById(setting_template.settingId)?.type === valueTypes.boolean"
									:false-value="false"
									:true-value="true"
									class="ma-0"
								/>
								<v-autocomplete 
									v-if="getGlobalSettingById(setting_template.settingId)?.type === valueTypes.integer"
									v-model="setting_template.settingValue"
									outlined
									dense
									:label="$t('GlobalSettingsPage.'+ getGlobalSettingById(setting_template.settingId)?.setting_key).title"
									:items="postingPriorityTypeValues"
									item-text="name"
									item-id="value"
								>
								</v-autocomplete>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn 
							color="success"
							text
							:loading="loading"
							@click="addFinancialFIleSetting()"
						>
							{{ $t('buttons.add') }}
						</v-btn>
						<v-btn
							color="redDarken1"
							text
							@click="customizeSettingDialog = false; setting_template.settingId = null"
						>
							{{ $t('buttons.cancel') }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="deleteDialog" width="550">
				<v-card>
					<v-card-title>
						{{ $t('GlobalSettingsPage.un-customize-setting') }}
					</v-card-title>
					<v-card-text>
						<p class="ma-0">
							{{ $t('GlobalSettingsPage.un-customize-setting-description') }}
						</p>
					</v-card-text>
					<v-card-actions>
						<v-btn
							text
							color="success"
							@click="deleteFinancialFileSetting(setting_id)"
						>
							{{ $t('buttons.ok') }}
						</v-btn>
						<v-btn
							text
							color="redDarken1"
							@click="deleteDialog = false"
						>
							{{ $t('buttons.cancel') }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-row class="justify-space-between">           
				<v-col cols="12" sm="6" xs="6" md="12" lg="3">
					<slot name="breadcrumbs" class="py-4"></slot>
				</v-col>
				<v-col cols="auto">
					<v-btn
						color="greenDarken1"
						class="white--text"
						:loading="loading"
						@click="customizeSettingDialog = true"
					>
						<v-icon> mdi-plus </v-icon>
						{{$t('buttons.customize')}}
					</v-btn>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6"  lg="4" v-for="setting in financialFileSettings" :key="setting.id">
					<v-card v-if="setting.type === valueTypes.integer" class="rounded-lg" height="100%">
						<v-card-title class="pb-0 pt-2 d-flex justify-space-between">
							<v-row class="justify-space-between">
								<v-col class="setting-title text-h6 d-flex px-2">
									<div v-html="$t('GlobalSettingsPage.' + setting.setting_key + '.icon')"></div>
									<p class="my-0 mx-1" style="white-space: normal; word-break: normal; overflow-wrap: break-word;">{{ $t('GlobalSettingsPage.' + setting.setting_key + '.title') }}</p>
								</v-col>
								<v-col cols="auto" class="px-2">
									<v-btn
										class="px-0"
										depressed
										color="red"
										small
										text
										@click="deleteDialog = true; setting_id = setting.id"
									>
										{{ $t('GlobalSettingsPage.un-customize') }}
		
									</v-btn>
								</v-col>
							</v-row>
						</v-card-title>
						<v-card-text class="pt-1 pb-2">
							<v-row>
								<v-col>
									<p class="description ma-0">
									</p>
								</v-col>
								<v-col cols="5" class="px-1">
									<v-autocomplete
										v-model="setting.setting_value"
										@change="changeSettingValue(setting)"
										dense
										solo
										:items="postingPriorityTypeValues"
										item-text="name"
										item-value="value"
										:hide-details="true"
									></v-autocomplete>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
					<v-card v-if="setting.type === valueTypes.boolean" class="rounded-lg" height="100%">
						<v-card-title class=" pb-0 pt-2">
							<v-row class="justify-space-between">
								<v-col class="setting-title text-h6 d-flex px-2" >
									<div v-html="$t('GlobalSettingsPage.' + setting.setting_key + '.icon')"></div>
									<p class="my-0 mx-1 " style="white-space: normal; word-break: normal; overflow-wrap: break-word;">{{ $t('GlobalSettingsPage.' + setting.setting_key + '.title') }}</p>
								</v-col>
								<v-col cols="auto" class="px-2">
									<v-btn
										class="px-0"
										depressed
										color="red"
										small
										text
										@click="deleteDialog = true; setting_id = setting.id"
									>
										{{ $t('GlobalSettingsPage.un-customize') }}
									</v-btn>
								</v-col>
							</v-row>
						</v-card-title>
						<v-card-text class="pt-0 pb-2">
							<v-row class="justify-space-between">
								<v-col>
									<p class="description ma-0">
									</p>
								</v-col>
								<v-col cols="auto" class="px-2">
									<v-switch
										v-model="setting.setting_value"
										readonly
										inset
										@click="changeSettingValue(setting)"
									/>
								</v-col>
							</v-row>
							<v-row>
	
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
	  
		</v-container>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { valueTypes, postingPriorityTypeValues } from '@/helpers/enums';
import eventBus from '@/event-bus';
export default {
	data () {
		return {
			financialFileSettings: [],
			valueTypes,
			postingPriorityTypeValues,
			customizeSettingDialog: false,
			deleteDialog: false,
			setting_template: {
				settingId: null,
				settingValue: false
			},
			loading: false,
			setting_id: null
		}
	},
	watch: {
		'setting_template.settingId'(val) {
			const setting = this.getGlobalSettingById(val)
			if(setting?.type === valueTypes.boolean) {
				this.setting_template.settingValue = false;
			} else if(setting?.type === valueTypes.integer) {
				this.setting_template.settingValue = null;
			}
		}
	},
	computed: {
		...mapState({
			globalSettings: state => state.settings.globalSettings.filter(v => v.is_active),
			settings: state => state.settings.settings.filter(v => v.is_active),
			currentFinancialFile: state => state.configs.configs?.financial_file
		}),
		...mapGetters({
			getGlobalSettingById: 'settings/getGlobalSettingById'
		}),
		getGlobalSettings() {
			return this.globalSettings?.filter(v => this.settings.findIndex(t => t.setting_key === v.setting_key) === -1)?.map(v => ({
				name: this.$t('GlobalSettingsPage.' + v.setting_key + '.title' ),
				id: v.id
			}))
		}
	},
	methods: {
		addFinancialFIleSetting() {
			this.loading = true;
			const setting = {
				id: this.setting_template.settingId,
				setting: {
					financial_file_id: this.currentFinancialFile?.id,
					type: this.getGlobalSettingById(this.setting_template.settingId)?.type,
					setting_value: this.setting_template.settingValue,
					note: ''
				}
			}
			this.$store.dispatch('settings/addFinancialFileSettings', setting).then( () =>{
				this.getFinancialFileSettings();
			}).finally(() => {
				this.loading = false;
			})
		},
		deleteFinancialFileSetting (id) {
			this.loading = true;
			this.$store.dispatch('settings/deleteFinancialFileSetting', {id: id , financial_file_id: this.currentFinancialFile?.id}).then( () =>{
				this.getFinancialFileSettings();
				this.loading = false;
				this.deleteDialog = false;
			})
		},
		getFinancialFileSettings() {
			this.$store.dispatch('settings/fetchFinancialFileSettings', this.currentFinancialFile?.id).then(data => {
				this.financialFileSettings = data.filter(v => v.is_active);
				this.customizeSettingDialog = false;
			})
		},
		changeSettingValue(setting) {
            const updateSetting = {...setting};
            if(updateSetting.type === valueTypes.boolean){
                updateSetting.setting_value = !updateSetting.setting_value;
            }
            this.$store.dispatch('settings/updateFinancialFileSettings', this.updateSettingPayload(updateSetting)).then( () =>{
                this.getFinancialFileSettings();
				eventBus.$emit('notification',this.$t('notifications.change-setting-alert'))
            })
        },
		updateSettingPayload(updateSetting){
			let setting = { 
				financial_file_id: updateSetting.financial_file_id,
				setting_value: updateSetting.setting_value,
				type: updateSetting.type,
				note: ''
			}
			return {
				setting: setting,
				id: updateSetting.id
			}
		},
	},
	mounted() {
		if(!this.settings.length) {
			this.getFinancialFileSettings();
		} else {
			this.financialFileSettings = this.settings
		}
	}
}
</script>
<style>
</style>